import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SessionGuard from "./pages/NoAuth";
import {WebSocketProvider} from "./WebSocketContext";
import NoAuth from "./pages/NoAuth";


function App() {
    return (
        <WebSocketProvider>
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/NoAuth" element={<NoAuth />} />
                <Route path="/dashboard" element={
                    <SessionGuard>
                        <Dashboard />
                    </SessionGuard>
                } />
            </Routes>
        </Router>
        </WebSocketProvider>
    );
}

export default App;